export const colorsBar = [
  '#2563eb',
  '#60a5fa',
  '#be185d',
  '#f59e42',
  '#4f4613',
  '#13c46f',
  '#9f00ff',
  '#c15454',
  '#228b22',
  '#eab410',
];

export const dateFormatter = (dateStr: string) =>
  new Intl.DateTimeFormat('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  }).format(new Date(dateStr));
